class MemoryStorage {
  constructor() {
    if (window.name.toString() != '' && window.name.toString() != 'app-iframe') {
      this.data = Object.assign(JSON.parse(window.name));
    } else {
      this.data = {}
    }
  }

  set(name, value) {
    this.data[name] = value;
  }

  get(name) {
    return JSON.stringify(this.data);
  }

  remove(name) {
    delete this.data[name];
  }

  contains(name) {
    return name in this.data;
  }
  /**
   * @name 清空
   */
  clear() {
    this.storage.clear();
  }
}

let localStorage, sessionStorage;
localStorage = new MemoryStorage();
sessionStorage = new MemoryStorage();

export default localStorage